import { ACTION } from "./constants";
import request from "../../../../utils/request";
import { requestConfig } from "../../../../config/apiResource";
import { showMainLoader, hideMainLoader } from "../../../actions";
import { formDataGenerator } from "../../../../utils/common";

export function getAboutUsContent() {
 
  return (dispatch) => {
    
    return request(requestConfig.getAboutUsNew())
      .then((json) => {
          json &&
          dispatch({ type: ACTION.GET_ABOUT_US_CONTENT, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about Landing data: " + error);
      });
  };
}
export function getAboutUsFinancialInfo(serverData, formData, type) {
  let formDataValue, typeData;

  if (serverData.url) {
    let data = {
      title: "",
      year: "",
      limit: 10,
      offset: "",
    };
    formDataValue = formDataGenerator(data);

    let urlArray = serverData.url.split("/");
    typeData = urlArray[urlArray.length - 1];
  } else {
    formDataValue = formData;
    typeData = type;
  }

  return (dispatch) => {
    return request(
      requestConfig.getAboutUsFinancialInfo(formDataValue, typeData)
    )
      .then((json) => {
        if (typeData == "annual-reports") {
          json && dispatch({ type: ACTION.GET_ANNUAL_REPORT, data: json.data });
        } else if (typeData == "financial-results") {
          json &&
            dispatch({ type: ACTION.GET_FINANCIAL_RESULT, data: json.data });
        } else if (typeData == "shareholder-presentation") {
          json &&
            dispatch({
              type: ACTION.GET_SHAREHOLDER_PRESENTATION,
              data: json.data,
            });
        }

        return json;
      })
      .catch((error) => {
        if (error.response) {
          // if there is response, it means its not a 50x, but 4xx
        } else {
          // gets activated on 50x errors, since no response from server
          // do whatever you want here :)
          console.log("Got Error with about content data: " + error);
        }
      });
  };
}
export function getAboutCorporateContent(serverData, type) {
  let filterTypeData;
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    filterTypeData = urlArray[urlArray.length - 1];
  } else {
    filterTypeData = type;
  }

  return (dispatch) => {
    return request(requestConfig.getAboutUsCorporateNew(filterTypeData))
      .then((json) => {
        (filterTypeData == "hdfc-mf-at-a-glance" ||
          filterTypeData == "what-we-stand-for" ||
          filterTypeData == "esg" ||
          filterTypeData == "what-sets-us-apart") &&
          json &&
          dispatch({
            type: ACTION.GET_HDFC_MF_GLANCE_CONTENT,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with corporate tab content: " + error);
      });
  };
}

export function getMessageContent(serverData, type) {
  let filterTypeData;
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    filterTypeData = urlArray[urlArray.length - 1];
  } else {
    filterTypeData = type;
  }

  return (dispatch) => {
    return request(requestConfig.getMessageFromLeadersNew(filterTypeData))
      .then((json) => {
        (filterTypeData == "board-of-directors" ||
          filterTypeData == "management-team" ||
          filterTypeData == "trustees") &&
          json &&
          dispatch({ type: ACTION.GET_LEADERSHIP_PROFILE, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about content data: " + error);
      });
  };
}

// ------------------------------------------------

export function getCorporateGovernanceContent(serverData, type) {
  let filterTypeData;
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    filterTypeData = urlArray[urlArray.length - 1];
  } else {
    filterTypeData = type;
  }
  return (dispatch) => {
    return request(requestConfig.getCorporateGovernanceNew(filterTypeData))
      .then((json) => {
        filterTypeData == "board-committee" &&
          json &&
          dispatch({ type: ACTION.GET_BOARD_COMMITTEE, data: json.data });
        filterTypeData == "dividend" &&
          json &&
          dispatch({ type: ACTION.GET_DIVIDEND, data: json.data });
        return json;
      })
      .catch((error) => {
        if (error.response) {
          // if there is response, it means its not a 50x, but 4xx
          console.log("about content", error.response);
        } else {
          // gets activated on 50x errors, since no response from server
          // do whatever you want here :)
          console.log("Got Error with about content data: " + error);
        }
      });
  };
}

export function getCorporateGovernancePost(serverData, formData, filter, type) {
  let formDataValue, defaultYear, typeData;
  if (serverData.url) {
    let data = {
      title: "",
      limit: 10,
      offset: 0,
    };
    formDataValue = formDataGenerator(data);
    defaultYear = "";
    let urlArray = serverData.url.split("/");
    typeData = urlArray[urlArray.length - 1];
  } else {
    formDataValue = formData;
    defaultYear = filter;
    typeData = type;
  }

  return (dispatch) => {
    return request(
      requestConfig.getCorporateGovernancePost(
        formDataValue,
        defaultYear,
        typeData
      )
    )
      .then((json) => {
        typeData == "code-policy" &&
          json &&
          dispatch({ type: ACTION.GET_CODE_GOVERNANCE, data: json.data });
        typeData == "disclosures" &&
          json &&
          dispatch({ type: ACTION.GET_DISCLOSURES, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about GET_ANNUAL_REPORT data: " + error);
      });
  };
}

export function getCorporateGovernanceDisclosure(data) {
  return (dispatch) => {
    return request(requestConfig.getCorporateGovernanceDisclosure(data))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_DISCLOSURES, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about GET_DISCLOSURES data: " + error);
      });
  };
}

export function getAboutUsMediaCenterNew({}, formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let params = {
      title: "",
      year: "",
      month: "",
    };
    formDataValue = formDataGenerator(params);
  } else {
    formDataValue = formData;
  }

  return (dispatch) => {
    return request(requestConfig.getAboutUsMediaCenterNew(formDataValue))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.GET_ABOUT_US_MEDIA_CENTER, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media pdf data: " + error);
      });
  };
}

export function getAboutUsMediaCenterVideo() {
  return (dispatch) => {
    return request(requestConfig.getAboutUsMediaCenterVideo())
      .then((json) => {
        json &&
          dispatch({
            type: ACTION.GET_ABOUT_US_MEDIA_CENTER_VIDEO,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}

export function postCsr(data) {
  let formDataValue;
  if (!__CLIENT__) {
    let params = {
      title: "",
      year: "",
      month: "",
    };
    formDataValue = formDataGenerator(params);
  } else {
    formDataValue = data;
  }
  return (dispatch) => {
    return request(requestConfig.postCsr(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_CSR, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about GET_DISCLOSURES data: " + error);
      });
  };
}
